import React, { useEffect, useRef, useState } from "react";
import { CREATE_CLIENT_QUOTE } from "../../../../utils/GraphQL/mutations";
import {
  GET_QUOTE_COUNT,
  GET_USER_INFO_FOR_TASKS,
} from "../../../../utils/GraphQL/queries";
import "./createQuoteModal.css";
// import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"; // used in old layout
import BdrModal from "../../../../components/BdrModal/BdrModal";
import BdrButton from "../../../../components/BdrButton/BdrButton";
import capitalizeFirstLetters from "../../../../utils/formatters/capitalizeFirstLetters";
import BAGroupTimeFormat from "../../../../utils/formatters/BAGroupTimeFormat";
import { priceStrFormatter } from "../../../../utils/formatters/priceStrFormatter";
import NewQuoteItemBox from "./NewQuoteItemBox";
import BdrSelectPopup from "../../../../components/BdrInput/BdrSelectPopup";
import {
  QUOTE_STATUS_OPTIONS,
  DISCOUNT_PERCENT_OPTIONS,
} from "../shared/quoteOptions";
import SpecialRefinisherPayBlock, {
  buildSpecialRefinisherPayInput,
  validateSpecialRefinisherPay,
} from "../../../../components/SpecialRefinisherPayBlock/SpecialRefinisherPayBlock";
import { useLazyQuery, useQuery, useMutation } from "@apollo/client";
import Auth from "../../../../utils/auth";
// eslint-disable-next-line no-unused-vars
import BdrInput from "../../../../components/BdrInput/BdrInput";
import CreateQuoteValidator from "../../../../utils/formValidators/createQuoteValidator";
import SendEmailModal from "../SendEmail/SendEmailModal";
import { useSnackbar } from "../../../../utils/GlobalSnackbar/GlobalSnackbarContext";
import { useConfirm } from "../../../../utils/GlobalConfirm/GlobalConfirmContext";
import EventDateTimeInput from "../EventDateTimeInput/EventDateTimeInput";
import NumberStepper from "../NumberStepper/NumberStepper";
import PostAddIcon from "@mui/icons-material/PostAdd";

// const logo = require("../../../../assets/images/BDR-logo.png"); // used in old layout

const clearedForm = {
  quoteStatus: "Active",
  // quoteViewed: [
  //   {
  //     type: String,
  //   },
  // ],
  dateCreated: "",
  createdBy: "",
  quoteItems: [
    // {
    //   itemName: "Double Doors, Int",
    //   price: "92356",
    //   quantity: "1",
    //   discountApplicable: true,
    // },
  ],
  quoteTotal: "0",
  subtotal: "",
  customerName: "",
  quoteNum: "",
  expirationDate: "",
  discountPercent: "10",
  quoteNote: "",
  quoteType: "",
  customerId: "",
  assigneeId: "22",
  assigneeName: "All",
  splitBetween: [],
};

const QTEBlank = {
  type: "quoteTemplate",
  // bigginsdoorrefinishing.com/client/view-quote/*quoteId
  quoteLink: [],
  toFirstName: "",
};

const CreateQuoteModal = ({
  clientObj,
  fetchClientInfo,
  quotesDisplayTrigger,
  /* Icon-only trigger for the client console's rail. Other callers keep the
     labelled button. */
  iconOnly,
}) => {
  const { handleSnack } = useSnackbar();
  const { confirm } = useConfirm();
  //   const mediaOver900 = useMediaQuery("(min-width: 900px)");
  //   const under600 = useMediaQuery("(max-width: 600px)");
  const [createQuoteGQLCall] = useMutation(CREATE_CLIENT_QUOTE);
  const { data: quoteNum, refetch: refetchQuoteCount } =
    useQuery(GET_QUOTE_COUNT);
  const [openModal, setOpenModal] = useState(false);
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [quoteForm, setQuoteForm] = useState({ ...clearedForm });
  const [quoteToEmailObj, setQuoteToEmailObj] = useState({ ...QTEBlank });
  const [formErrors, setFormErrors] = useState([]);
  const [discountTotal, setDiscountTotal] = useState("0");
  const [quoteCount, setQuoteCount] = useState("0");
  const [splitMin, setSplitMin] = useState("");
  const [splitMax, setSplitMax] = useState("");
  const [srpEnabled, setSrpEnabled] = useState(false);
  const [srpAmount, setSrpAmount] = useState(null);
  const [srpPayType, setSrpPayType] = useState(null);
  const messageInput = useRef();
  const timeoutIdRef = useRef();
  const [usersInfo, setUsersInfo] = useState([]);
  const [getUsersInfoCall] = useLazyQuery(GET_USER_INFO_FOR_TASKS);
  const [selectedUserIndex, setSelectedUserIndex] = useState(0);
  const [afterLastUserIndex, setAfterLastUserIndex] = useState(0);

  const quoteValidator = new CreateQuoteValidator(quoteForm);

  useEffect(() => {
    // used to getting the most recent quote num.
    // In case of back to back quote creations
    refetchQuoteCount();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  useEffect(() => {
    if (clientObj?._id) {
      setQuoteForm((prev) => ({
        ...prev,
        customerName: `${clientObj?.firstName} ${clientObj?.lastName}`,
        customerId: clientObj?._id,
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientObj, openModal]);

  useEffect(() => {
    const timeoutId = timeoutIdRef.current;
    return () => {
      clearTimeout(timeoutId);
    };
  }, []);

  useEffect(() => {
    if (quoteNum?.getQuoteCount) {
      setQuoteCount((parseInt(quoteNum?.getQuoteCount) + 2)?.toString());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteNum]);

  useEffect(() => {
    const totalArr = quoteForm?.quoteItems?.map((item) => {
      return parseInt(
        makeTotal(
          parseInt(item?.price),
          parseInt(item?.quantity),
          item?.discountApplicable
        )
      );
    });

    const subtotalArr = quoteForm?.quoteItems?.map((item) => {
      return parseInt(
        makeTotal(parseInt(item?.price), parseInt(item?.quantity), false)
      );
    });

    const quoteTotal = totalArr?.reduce((price, price2) => price + price2, 0);
    const subtotal = subtotalArr?.reduce((price, price2) => price + price2, 0);

    const discountOff = subtotal - quoteTotal;
    setDiscountTotal(`${discountOff}`);
    setQuoteForm((prev) => ({
      ...prev,
      quoteTotal: `${quoteTotal}`,
      subtotal: `${subtotal}`,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteForm?.quoteItems, quoteForm?.discountPercent]);

  useEffect(() => {
    if (usersInfo?.length <= 0 && openModal) {
      makeGetInfoCall();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [openModal]);

  const makeGetInfoCall = async () => {
    const { data } = await getUsersInfoCall();

    if (data?.getUsersNamesForTasks) {
      const index = data?.getUsersNamesForTasks?.length + 1;
      setSelectedUserIndex(index);
      setAfterLastUserIndex(index);
      setUsersInfo([...data?.getUsersNamesForTasks]);
    }
  };

  useEffect(() => {
    const { firstName, lastName } = Auth.getProfile()?.data;
    const now = Date.now();

    const expDate = new Date(now + 1000 * 60 * 60 * 24 * 90);
    expDate.setHours(22, 0, 0, 0); // Default expiration to 10 PM

    setQuoteForm((prev) => ({
      ...prev,
      dateCreated: `${now}`,
      expirationDate: `${expDate.getTime()}`,
      createdBy: `${firstName} ${lastName}`,
    }));
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [quoteNum, openModal]);

  const addQuoteItem = (newItem) => {
    if (formErrors?.length > 0) {
      clearFormErrors();
    }
    setQuoteForm((prev) => ({
      ...prev,
      quoteItems: [...prev?.quoteItems, newItem] || [newItem],
    }));
  };

  const makeTotal = (price, quantity, discount) => {
    const total = discount
      ? (
          (((100 - parseInt(quoteForm?.discountPercent)) / 100) *
            price *
            quantity) /
          100
        )
          ?.toFixed(2)
          .replace(".", "")
      : ((price * quantity) / 100)?.toFixed(2).replace(".", "");

    return total;
  };

  const removeQuoteItem = (index) => {
    const arr = Array.from(quoteForm?.quoteItems);
    arr?.splice(index, 1);

    handleSnack("Item Removed", 2000);
    setQuoteForm((prev) => ({ ...prev, quoteItems: arr }));
  };

  const handleChange = (event) => {
    const name = event.target.name;
    let value = event.target.value;

    if (name === "text") {
      messageInput.current?.scrollIntoView();
    }

    if (name === "discountPercent") {
      value = value.replace(/[^0-9]/gi, "");
    }

    setQuoteForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleChangeAssignee = (index) => {
    setSelectedUserIndex(index);

    if (index !== afterLastUserIndex) {
      const selected = usersInfo?.[index];

      setQuoteForm((prev) => ({
        ...prev,
        assigneeId: selected?._id || "",
        assigneeName: `${selected?.firstName} ${selected?.lastName}`,
      }));

      return;
    }

    setQuoteForm((prev) => ({
      ...prev,
      assigneeId: "22",
      assigneeName: "All",
    }));
  };

  const clearFormErrors = () => {
    setFormErrors([]);
  };

  const buildSplitBetween = () => {
    const minVal = parseInt(splitMin);
    const maxVal = parseInt(splitMax);
    if (!isNaN(minVal) && !isNaN(maxVal)) {
      return [minVal, maxVal];
    }
    if (!isNaN(minVal)) {
      return [minVal];
    }
    return [];
  };

  const createQuote = async (event) => {
    // Read the button's identity BEFORE the first await. Which of the two
    // submit buttons was pressed used to be re-read off `event.target` much
    // further down, after several awaits — that survives only because the
    // buttons have plain text labels, so the click target IS the <button>.
    // Give either one an icon and the target becomes the icon, `name` reads
    // undefined, and "Create & Email" silently stops emailing.
    const submitMode = event?.target?.name;
    const valid = await quoteValidator.createClientQuoteValid();

    if (valid !== true) {
      // Hard errors block outright, exactly as before the hard/soft split.
      if (valid.hard?.length > 0) {
        setFormErrors([...valid.hard]);
        return;
      }
      // Soft-only = $0 money values (warranty / no-charge job). Confirm
      // instead of block. One confirm per save gesture — GlobalConfirm
      // serializes and a second call would cancel the first.
      const zeroTotal = parseInt(quoteForm?.quoteTotal) === 0;
      const ok = await confirm({
        title: zeroTotal ? "Create $0.00 quote?" : "$0.00 line item",
        message: zeroTotal
          ? "This quote totals $0.00. Create it anyway? (Warranty / no-charge job — the refinisher can still be paid via Special Refinisher Pay.)"
          : "This quote contains item(s) priced at $0.00. Save anyway?",
        confirmLabel: zeroTotal ? "Create Quote" : "Save",
      });
      if (!ok) return;
    }

    const jobTypesArr = quoteForm?.quoteItems?.map((item) => {
      if (item?.jobType === "Refinish") {
        return true;
      }
      return false;
    });

    const quoteTypeAnswer = jobTypesArr?.includes(true)
      ? "Refinish"
      : "Maintenance";

    const splitBetweenArr = buildSplitBetween();

    const srpValidationError = validateSpecialRefinisherPay(srpEnabled, srpAmount);
    if (srpValidationError) {
      setFormErrors([srpValidationError]);
      return;
    }
    const srpPayload = buildSpecialRefinisherPayInput(srpEnabled, srpAmount, srpPayType);

    const resetSrp = () => {
      setSrpEnabled(false);
      setSrpAmount(null);
      setSrpPayType(null);
    };

    if (submitMode === "saveOnly") {
      const { data } = await createQuoteGQLCall({
        variables: {
          ...quoteForm,
          quoteType: quoteTypeAnswer,
          splitBetween: splitBetweenArr,
          specialRefinisherPay: srpPayload,
        },
      });

      if (data?.createClientQuote) {
        setQuoteForm({ ...clearedForm });
        setSplitMin("");
        setSplitMax("");
        resetSrp();
        fetchClientInfo();
        handleSnack("Quote & F/U Task Created", 3000);
        setOpenModal(false);
        const id = setTimeout(() => {
          quotesDisplayTrigger();
        }, 500);
        timeoutIdRef.current = id;
        return;
      }
    }

    if (event.target.name === "createAndEmail") {
      const { data } = await createQuoteGQLCall({
        variables: {
          ...quoteForm,
          splitBetween: splitBetweenArr,
          specialRefinisherPay: srpPayload,
        },
      });

      if (data?.createClientQuote) {
        setQuoteForm({ ...clearedForm });
        setSplitMin("");
        setSplitMax("");
        resetSrp();
        fetchClientInfo();
        handleSnack("Quote Created", 3000);
        setOpenModal(false);

        setQuoteToEmailObj({
          type: "quoteTemplate",
          // https://bigginsdoorrefinishing.com/client/view-quote/*quoteId
          quoteLink: [
            `https://bigginsdoorrefinishing.com/client/view-quote/${data?.createClientQuote?.id}`,
          ],
          toFirstName: clientObj?.firstName || "",
        });

        const id = setTimeout(() => {
          changeParentForEmailModal(true);
        }, 700);

        timeoutIdRef.current = id;
        return;
      }
    }

    handleSnack("Something went wrong...Please Try Again", 3000);
  };

  const changeParentForEmailModal = (bool) => {
    setOpenEmailModal(bool);
  };

  const handleCloseModal = () => {
    setQuoteForm((prev) => ({
      ...clearedForm,
      customerName: prev?.customerName,
      expirationDate: prev?.expirationDate,
    }));
    setSplitMin("");
    setSplitMax("");
    setOpenModal(false);
  };

  const handleExpirationChange = (msStr) => {
    if (typeof msStr !== "string") return;
    setQuoteForm((prev) => ({ ...prev, expirationDate: msStr }));
  };

  return (
    <>
      {/* Was a BdrRowButton while this sat in the client page's stack of
          disclosure rows. The console moves it into the rail's action group
          beside Edit Client / Create Task / Delete, so it is a button again.
          `action` — it opens a form, it commits nothing. */}
      <BdrButton
        variant="action"
        icon={<PostAddIcon />}
        iconOnly={!!iconOnly}
        ariaLabel="Create Quote"
        onClick={(event) => {
          event.stopPropagation();
          setOpenModal(true);
        }}
      >
        Create Quote
      </BdrButton>
      {openEmailModal && (
        <SendEmailModal
          sendTo={clientObj?.primaryEmail}
          templateObj={quoteToEmailObj}
          changeParent={changeParentForEmailModal}
        />
      )}
      <BdrModal
        open={openModal}
        onClose={handleCloseModal}
        variant="panel"
        size="lg"
        /* keeps its own header — it carries the quote number alongside the
           title, which the shell's header bar has no slot for */
        showHeader={false}
        ariaLabel="Create Quote"
      >
        <div className="cq-v2-content bdr-dark-placeholder">
          {/* Header */}
          <div className="cq-v2-header">
            <h3 className="cq-v2-title">Create Quote</h3>
            <div className="cq-v2-header-meta">
              <span className="cq-v2-quote-num">Quote #{quoteCount}</span>
              {/* The shell's own close button, reused — this header is
                  hand-rolled only because it carries the quote number. */}
              <button
                type="button"
                className="bdr-modal-close"
                aria-label="Close"
                onClick={handleCloseModal}
              >
                ×
              </button>
            </div>
          </div>

          {/* Client Info Bar */}
          <div className="cq-v2-client-bar">
            <span className="cq-v2-field-label">Client</span>
            <span className="cq-v2-client-name">
              {capitalizeFirstLetters(quoteForm?.customerName)}
            </span>
          </div>

          {/* Config Row: Status, Discount, Assignee */}
          <div className="cq-v2-config-row">
            <div className="cq-v2-select-group">
              <span className="cq-v2-field-label">Status</span>
              <BdrSelectPopup
                id="cq-quote-status"
                className="bdr-input bdr-select-trigger"
                name="quoteStatus"
                value={quoteForm?.quoteStatus}
                onChange={handleChange}
                options={QUOTE_STATUS_OPTIONS}
              />
            </div>
            <div className="cq-v2-select-group">
              <span className="cq-v2-field-label">Discount %</span>
              <BdrSelectPopup
                id="cq-discount-percent"
                className="bdr-input bdr-select-trigger"
                name="discountPercent"
                value={quoteForm?.discountPercent}
                onChange={handleChange}
                options={DISCOUNT_PERCENT_OPTIONS}
              />
            </div>
            <div className="cq-v2-select-group">
              <span className="cq-v2-field-label">Assign F/U To</span>
              <BdrSelectPopup
                id="cq-assign-fu"
                className="bdr-input bdr-select-trigger"
                value={selectedUserIndex}
                onChange={(e) => handleChangeAssignee(parseInt(e.target.value))}
                options={[
                  ...(usersInfo || []).map((userInfo, index) => ({
                    value: index,
                    label: `${userInfo?.firstName} ${userInfo?.lastName}`.trim(),
                  })),
                  { value: afterLastUserIndex, label: "All" },
                ]}
              />
            </div>
          </div>

          {/* Min/Max Refinishers Row */}
          <div className="cq-v2-refinishers-row">
            <span className="cq-v2-field-label">Refinishers</span>
            <div className="cq-v2-refinisher-inputs">
              <NumberStepper
                label="Min"
                value={splitMin}
                onChange={(val) => setSplitMin(String(val))}
                min={1}
                max={99}
              />
              <NumberStepper
                label="Max"
                value={splitMax}
                onChange={(val) => setSplitMax(String(val))}
                min={1}
                max={99}
              />
            </div>
          </div>

          {/* Special Refinisher Pay override */}
          <div className="cq-v2-refinishers-row">
            <SpecialRefinisherPayBlock
              enabled={srpEnabled}
              setEnabled={setSrpEnabled}
              amount={srpAmount}
              setAmount={setSrpAmount}
              payType={srpPayType}
              setPayType={setSrpPayType}
              theme="dark"
              items={quoteForm?.quoteItems}
            />
          </div>

          {/* Dates Row: Quote Date + Expiration */}
          <div className="cq-v2-dates-row">
            <div className="cq-v2-date-field">
              <span className="cq-v2-field-label">Quote Date:</span>
              <span className="cq-v2-date-readonly">
                {BAGroupTimeFormat(quoteForm?.dateCreated, false, true)}
              </span>
            </div>
            <div className="cq-v2-date-field">
              <EventDateTimeInput
                value={quoteForm?.expirationDate}
                onChange={handleExpirationChange}
                label="Expires:"
                hideTime
                defaultTime={{ hour: 10, minute: 0, amPm: "PM" }}
              />
            </div>
          </div>

          {/* Error Messages */}
          {formErrors?.length > 0 && (
            <div className="cq-v2-errors">
              <ul>
                {formErrors.map((err, i) => (
                  <li key={err + i}>{err}</li>
                ))}
              </ul>
            </div>
          )}

          {/* Items Section */}
          <div className="cq-v2-items-section">
            <span className="cq-v2-section-label">Quote Items</span>

            {/* Add Item Controls */}
            <div className="cq-v2-add-item-box">
              <NewQuoteItemBox
                discountPercent={parseInt(quoteForm?.discountPercent)}
                addQuoteItem={addQuoteItem}
                handleSnack={handleSnack}
              />
            </div>

            {/* Items List */}
            {quoteForm?.quoteItems?.length > 0 && (
              <div className="cq-v2-items-list">
                <div className="cq-v2-items-header">
                  <span className="cq-v2-ih-name">Item</span>
                  <span className="cq-v2-ih-price">Price</span>
                  <span className="cq-v2-ih-qty">Qty</span>
                  <span className="cq-v2-ih-disc">Disc.</span>
                  <span className="cq-v2-ih-total">Total</span>
                  <span className="cq-v2-ih-action"></span>
                </div>
                {quoteForm.quoteItems.map((item, index) => {
                  const total = makeTotal(
                    parseInt(item?.price),
                    parseInt(item?.quantity),
                    item?.discountApplicable
                  );
                  return (
                    <div key={`cq-v2-item-${index}`} className="cq-v2-item-row">
                      <span className="cq-v2-ir-name">{item?.itemName}</span>
                      <span className="cq-v2-ir-price">{priceStrFormatter(item?.price)}</span>
                      <span className="cq-v2-ir-qty">{item?.quantity}</span>
                      <span className="cq-v2-ir-disc">
                        {item?.discountApplicable
                          ? quoteForm?.discountPercent === "0" ? "N/A" : `${quoteForm.discountPercent}%`
                          : "N/A"}
                      </span>
                      <span className="cq-v2-ir-total">{priceStrFormatter(total)}</span>
                      <span className="cq-v2-ir-action">
                        {/* plain + sm: an icon action inside a dense row,
                            where an outline on every line would be noise
                            (§6b). No destructive confirm — the item is not
                            saved yet, so removing it costs nothing. */}
                        <BdrButton
                          variant="plain"
                          size="sm"
                          onClick={() => removeQuoteItem(index)}
                          ariaLabel={`Remove ${item?.itemName || "item"}`}
                          title="Remove item"
                        >
                          ×
                        </BdrButton>
                      </span>
                    </div>
                  );
                })}
              </div>
            )}

            {/* Totals */}
            <div className="cq-v2-totals">
              <div className="cq-v2-total-row">
                <span>Subtotal</span>
                <span>{priceStrFormatter(quoteForm?.subtotal)}</span>
              </div>
              {discountTotal > 0 && (
                <div className="cq-v2-total-row cq-v2-discount-row">
                  <span>Discount</span>
                  <span>- {priceStrFormatter(discountTotal)}</span>
                </div>
              )}
              <div className="cq-v2-total-row cq-v2-grand-total">
                <strong>Total</strong>
                <strong>{priceStrFormatter(quoteForm?.quoteTotal)}</strong>
              </div>
            </div>
          </div>

          {/* Quote Note */}
          <div className="cq-v2-field">
            <BdrInput
              /* inputRef, not ref: BdrInput is not a forwardRef, so `ref`
                 silently stays null and the scrollIntoView below never
                 fires. `sx` was a leftover MUI prop — it spread onto the
                 textarea as an unknown DOM attribute. */
              inputRef={messageInput}
              label="Quote Note (optional)"
              name="quoteNote"
              value={quoteForm?.quoteNote}
              onChange={handleChange}
              multiline
              rows={3}
            />
          </div>

          {/* Action Buttons */}
          <div className="cq-v2-actions">
            <BdrButton onClick={handleCloseModal}>Cancel</BdrButton>
            {/* solid: this modal is variant="panel", the saturated
                --bdr-grad-panel, where a tinted fill muddies in (§6b). */}
            {/* Subdued, though it sits on a panel: this row offers two
                variants of the SAME commit, and "Create & Email" does more,
                so it takes the solid primary. See §6b — the one case where
                something other than the surface picks the weight. */}
            <BdrButton
              name="saveOnly"
              variant="confirm"
              onClick={(event) => {
                clearFormErrors();
                createQuote(event);
              }}
            >
              Create Quote
            </BdrButton>
            <BdrButton
              name="createAndEmail"
              variant="confirm-solid"
              onClick={(event) => {
                clearFormErrors();
                createQuote(event);
              }}
            >
              Create &amp; Email
            </BdrButton>
          </div>
        </div>
      </BdrModal>
    </>
  );
};

export default CreateQuoteModal;
